import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 分项谈判采购路由生成函数
 * @param modulePath
 * @param prefix
 * @param sideMenuTitle
 * @param applicableCompanyIdentities
 * @param roles
 * @returns <Object> route
 */
export default function generateNegotiationItemizedRoutes(
  modulePath = 'negotiation-itemized',
  prefix = '',
  sideMenuTitle = '谈判采购',
  applicableCompanyIdentities = [workbenchServiceDict.PURCHASER.value],
  roles = [platformFunctionModuleDict.PURCHASER.right]
) {
  return {
    path: modulePath,
    type: menuTypeDict.DIRECTORY.value,
    meta: {
      title: sideMenuTitle,
      icon: 'icon-side_purchase_negotiation',
      layout: 'DefaultLayout'
    },
    applicableCompanyTypes: [
      { companyType: companyTypeDict.ENTERPRISE.value },
      { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
    ],
    platformAlias: [],
    applicableCompanyIdentities,
    roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
    superviseInstitutions: [],

    children: [
      // 项目管理
      {
        path: 'manage',
        type: menuTypeDict.DIRECTORY.value,
        meta: {
          title: '项目管理'
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: [],

        children: [
          // 项目列表
          {
            path: 'list',
            name: `${prefix}NegotiationPackageList`,
            component: '/procure-views/negotiation/package/index',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '项目列表',
              cache: true,
              hidden: true,
              pageComponentName: 'NegotiationPackageList'
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 发布项目
          {
            path: 'create/project/:projectId?/order/:orderIds?',
            name: `${prefix}NegotiationPackageForm`,
            component: '/procure-views/negotiation/package/form',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '发布项目',
              hidden: true,
              needFormKey: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 项目详情
          {
            path: 'detail/project/:projectId?',
            name: `${prefix}NegotiationPackageDetail`,
            component: '/procure-views/negotiation/package/detail',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '项目详情',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          }
        ]
      },

      // 谈判采购
      {
        path: 'purchase',
        type: menuTypeDict.DIRECTORY.value,
        meta: {
          title: '谈判采购',
          layout: 'DefaultLayout'
        },
        applicableCompanyTypes: [
          { companyType: companyTypeDict.ENTERPRISE.value },
          { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
        ],
        platformAlias: [],
        applicableCompanyIdentities,
        roles: [...roles, platformFunctionModuleDict.BUSINESS_MANAGEMENT.right],
        superviseInstitutions: [],

        children: [
          // 项目列表
          {
            path: 'list',
            name: `${prefix}NegotiationV2List`,
            component: '/procure-views/negotiation/v2/index',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '项目列表',
              cache: true,
              hidden: true,
              pageComponentName: 'NegotiationV2List'
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 发布谈判
          {
            path: 'orders/:orderId?/edit/:isAbnormal?/copy/:isCopy?',
            name: `${prefix}NegotiationV2Form`,
            component: '/procure-views/negotiation/v2/form',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '发布谈判',
              hidden: true,
              needFormKey: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 谈判单详情
          {
            path: 'orders/:orderId/info',
            name: `${prefix}NegotiationV2Info`,
            component: '/procure-views/negotiation/v2/process/info/index',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '谈判单详情',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 接受报价
          {
            path: 'orders/:orderId/quota/:applyId?',
            name: `${prefix}NegotiationV2Quote`,
            component: '/procure-views/negotiation/v2/process/quota/index',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '接受报价',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 供应商详情
          {
            path: 'orders/:orderId/audit/supplier/:applyId',
            name: `${prefix}NegotiationV2SupplierDetail`,
            component:
              '/procure-views/negotiation/v2/process/quota/supplier-detail',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '供应商详情',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 报价详情
          {
            path: 'orders/:orderId/audit/:offerId/quota/detail',
            name: `${prefix}NegotiationV2QuoteDetail`,
            component:
              '/procure-views/negotiation/v2/process/quota/quota-detail',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '报价详情',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 比价单
          {
            path: 'orders/:orderId/compare/detail',
            name: `${prefix}NegotiationV2CompareDetail`,
            component:
              '/procure-views/negotiation/v2/process/quota/compare-detail',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '比价单',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 候选公示
          {
            path: 'orders/:orderId/candidate/result/:abnormal?',
            name: `${prefix}NegotiationV2Candidate`,
            component: '/procure-views/negotiation/v2/process/candidate/index',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '候选公示',
              hidden: true,
              needFormKey: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 候选详情
          {
            path: 'orders/:orderId/candidate/detail',
            name: `${prefix}NegotiationV2CandidateDetail`,
            component: '/procure-views/negotiation/v2/process/candidate/detail',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '候选详情',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 成交公示
          {
            path: 'orders/:orderId/winner/result/:abnormal?',
            name: `${prefix}NegotiationV2Winner`,
            component: '/procure-views/negotiation/v2/process/winner/index',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '成交公示',
              hidden: true,
              needFormKey: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 成交详情
          {
            path: 'orders/:orderId/winner/detail',
            name: `${prefix}NegotiationV2WinnerDetail`,
            component: '/procure-views/negotiation/v2/process/winner/detail',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '成交详情',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 变更公告
          {
            path: 'orders/:orderId/content-change',
            name: `${prefix}NegotiationV2ContentChange`,
            component: '/procure-views/negotiation/v2/changes/content-change',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '变更公告',
              hidden: true,
              needFormKey: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 变更详情
          {
            path: 'orders/:orderId/content-change-detail',
            name: `${prefix}NegotiationV2ChangeNewestDetail`,
            component:
              '/procure-views/negotiation/v2/changes/content-change-newest',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '变更详情',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 澄清文件
          {
            path: 'orders/:orderId/clarification',
            name: `${prefix}NegotiationV2Clarification`,
            component: '/procure-views/negotiation/v2/changes/clarification',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '澄清文件',
              hidden: true,
              needFormKey: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 流标处理
          {
            path: 'orders/:orderId/auction',
            name: `${prefix}NegotiationV2Auction`,
            component: '/procure-views/negotiation/v2/abnormal/auction',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '流标处理',
              hidden: true,
              needFormKey: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 流标详情
          {
            path: 'orders/:orderId/auction-detail',
            name: `${prefix}NegotiationV2AuctionNewestDetail`,
            component: '/procure-views/negotiation/v2/abnormal/auction-newest',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '流标详情',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 批量公示
          {
            path: 'batch/order/:orderIds?/candidate/abnormal/:isAbnormal?',
            name: `${prefix}NegotiationV2BatchCandidate`,
            component: '/procure-views/negotiation/v2/batch/candidate',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '批量公示',
              hidden: true,
              needFormKey: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 批量公告
          {
            path: 'batch/order/:orderIds?/winner',
            name: `${prefix}NegotiationV2BatchWinner`,
            component: '/procure-views/negotiation/v2/batch/winner',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '批量公告',
              hidden: true,
              needFormKey: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 批量修改公告
          {
            path: 'batch/order/:orderIds?/change-winner',
            name: `${prefix}NegotiationV2BatchChangeWinner`,
            component: '/procure-views/negotiation/v2/batch/change-winner',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '批量修改公告',
              hidden: true,
              needFormKey: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 追加供应商
          {
            path: 'orders/:orderId/abnormal/add-supplier',
            name: `${prefix}NegotiationV2AddSupplier`,
            component: '/procure-views/negotiation/v2/abnormal/add-supplier',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '追加供应商',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 批量答疑澄清
          {
            path: 'batch/order/:orderIds?/clarification',
            name: `${prefix}NegotiationV2BatchClarification`,
            component: '/procure-views/negotiation/v2/batch/clarification',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '批量答疑澄清',
              hidden: true,
              needFormKey: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 批量变更公告
          {
            path: 'batch/order/:orderIds?/change',
            name: `${prefix}NegotiationV2BatchChange`,
            component: '/procure-views/negotiation/v2/batch/change',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '批量变更公告',
              hidden: true,
              needFormKey: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 批量流标
          {
            path: 'batch/order/:orderIds?/auction',
            name: `${prefix}NegotiationV2BatchAuction`,
            component: '/procure-views/negotiation/v2/batch/auction',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '批量流标',
              hidden: true,
              needFormKey: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 保证金退款
          {
            path: 'orders/:orderId/guarantee/refund/list',
            name: `${prefix}NegotiationV2GuaranteeRefund`,
            component: '/procure-views/negotiation/v2/guarantee/refund',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '保证金退款',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          },

          // 批量追加供应商
          {
            path: 'batch/order/:orderIds?/add/supplier',
            name: `${prefix}NegotiationV2BatchAddSupplier`,
            component: '/procure-views/negotiation/v2/batch/add-supplier',
            type: menuTypeDict.MENU.value,
            meta: {
              title: '批量追加供应商',
              hidden: true
            },
            applicableCompanyTypes: [
              { companyType: companyTypeDict.ENTERPRISE.value },
              { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
            ],
            platformAlias: [],
            applicableCompanyIdentities,
            roles: [
              ...roles,
              platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
            ],
            superviseInstitutions: []
          }
        ]
      }
    ]
  }
}
